import React from 'react';
import styled from 'styled-components';

import Dropzone from 'react-dropzone';

import { Typography, Avatar, Button } from '@material-ui/core';

import CloudUploadIcon from '../../assets/icon-cloud-upload-wei.svg';

/* eslint-disable indent */
const Root = styled.div`
	margin-right: 20px;
	padding: 10px;
	border-radius: 5px;
	border: 1px solid ${(props) => props.theme.palette.dropzone.borderColor};
	background-image: ${(props) => props.theme.palette.dropzone.backgroundImage};
	color: ${(props) => props.theme.palette.dropzone.color};
	text-align: center;
	cursor: pointer;

	.dropzone__wrap {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;

		p {
			margin-bottom: 20px;
		}
	}

	.MuiAvatar-root {
		margin: 0 auto 20px auto;
	}

	.MuiButton-root {
		padding: 10px 20px;
		background-color: ${(props) =>
			props.theme.palette.dropzone.button.backgroundColor};
		font-weight: bold;
		text-transform: initial;
		border-radius: 50px;
		transition: background-color 250ms, color 250ms;

		&:hover {
			background-color: ${(props) =>
				props.theme.palette.dropzone.button.backgroundColorHover};
			color: ${(props) => props.theme.palette.dropzone.button.colorHover};
		}
	}

	*:focus {
		outline: none;
	}
`;

const DropzoneDefault = ({ accept, isLoading, uploadFile, multiple, cancelLoading }) => {
	let component = null;
	switch (isLoading) {
		case 1:
			component = (
				<>
					<Typography variant="body2">Daten werden verarbeitet....</Typography>
					<Button onClick={cancelLoading}>Abbrechen</Button>
				</>
			);
			break;
		case 2:
			component = (
				<>
					<Avatar src={CloudUploadIcon} alt="CloudUploadIcon" />
					<Typography variant="body2">
						Lastgang erfolgreich verarbeitet! Bitte füllen Sie die Felder aus
						und drücken Sie auf "Berechnen" um die Daten im Dashboard zu
						sehen.
					</Typography>

					<Button onClick={cancelLoading}>Abbrechen</Button>
				</>
			);
			break;
		default:
			component = (
				<>
					<Avatar src={CloudUploadIcon} alt="CloudUploadIcon" />
					<Typography variant="body1">Drag & Drop</Typography>
					<Typography variant="body2" className="dropzoneSubline">
						Wählen Sie eine CSV, XLS, XLM oder XLSX Datei
					</Typography>
				</>
			);
	}

	return (
		<Root>
			<Dropzone
				disabled={isLoading !== 0 ?? true}
				accept={accept}
				onDrop={uploadFile}
				multiple={multiple}
			>
				{({ getRootProps, getInputProps }) => (
					<div {...getRootProps()} className="dropzone__wrap">
						<input {...getInputProps()} />
						<div>{component}</div>
					</div>
				)}
			</Dropzone>
		</Root>
	);
};

export default DropzoneDefault;
